<template>
  <div :class="[`col-lg-${span}`]">
    <label>{{ label }}</label>
    <input type="text" class="form-control" :placeholder="placeholder" :value="value" :disabled="disabled" @input="$emit('input', $event.target.value)" />
  </div>
</template>

<script>
export default {
  props: ["value", "fieldKey", "label", "placeholder", "span", "disabled"],
};
</script>
